(function (w, d, i) {

    let cookieStore = 'en'
    function getCookie(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    }

          const storename = getCookie('storename')
        if (storename) {
            let arr = storename.split("&&&")
            if (Array.isArray(arr)) {
                cookieStore = arr[1]
            }
        }

      const tip = {
        en: "Have questions?  Get help from a Hasselblad expert. ",
        fr: "Des questions ? Contactez un expert Hasselblad."
    }
  
  w[i] || (w[i] = {});
  const el = document.getElementById("support-echat");
  const chatIcon = el.dataset.chatIcon;
  w[i].config = {
    lang: "en",
    region: "US",
    appId: "hasselblad",
    appName: "hasselblad",
    appUserId: "hasselblad",
    env: "prod",
    hideTop: true,
    openWindowDirectlyOnMobile: true,
    data: {
      list: [
        {
          slug: "customer",
          "support-customer": {
            icon: chatIcon,
            tip: tip[cookieStore] || tip.en,
            title: "客服服务",
            showDelay: "10",
          },
        },
        {
          slug: "support-echat",
          echat: {
            url: "https://fusioncx.lydaas.com/chat-scsp/index.html?instanceId=MTI3OTI%3D&xsp_tenantid=300001001&terminalType=1&preview=1&lang=en_US",
          },
        },
      ],
    },
    showTips: true,
  };
  var s = d.createElement("script");
  s.setAttribute("defer", "");
  s.setAttribute("crossorigin", "");
  s.setAttribute("src", u);
  (d.body || d.head).appendChild(s);
})(
  window,
  document,
  "__EChat__"
);
